Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};
Greenmile.PanelBuilder.Fields = Greenmile.PanelBuilder.Fields || {};

Greenmile.PanelBuilder.Fields.ComplexField = (function () {

    function ComplexField (field, entity) {

        Greenmile.PanelBuilder.Fields.Base.apply(this, arguments);

        var fieldContainerClass = 'complexField';

        this.selectFieldList = new Greenmile.PanelBuilder.Fields.RuleSelectFieldList(entity);
        this.operators = [
            { value: 'PLUS', label: 'Operators.plus' },
            { value: 'MINUS', label: 'Operators.minus' }
        ];

        this.getValue = function () {
            var selectedField = this.selectFieldList.getSelectedField();
            var additionalOperation = this.pickListOperator.getValue();

            var value = {
                entityField: { id: field.id },
                attribute: field.name,
                operation: this.pickListComparator.getValue(),
                value: this.fieldRendered.getValue().toString()
            };

            if (additionalOperation) {
                value.additionalOperation = additionalOperation;
                value.additionalValue = this.fieldRendered.getValue();
            }

            if (selectedField) {
                value.value = '@' + selectedField.name + '@';
            }

            if (this.id) {
                value.id = this.id;
            }

            return value;
        };

        this.setValue = function (data) {
            this.id = data.id;
            field = data.entityField;
            this.pickListComparator.setValue(data.operation);
            var fieldValue = data.value;
            fieldValue = fieldValue.replace(/@/g, '');
            
            if (data.additionalOperation) {
                this.selectFieldList.setSelectedField({ name: fieldValue });
                this.fieldRendered.setValue(Greenmile.PanelBuilder.Utils.getValueToUserFormat(field, data.additionalValue));
                this.pickListOperator.setValue(data.additionalOperation);
            } else {
                if (data.value.indexOf('@') === -1) {
                    this.fieldRendered.setValue(Greenmile.PanelBuilder.Utils.getValueToUserFormat(field, fieldValue));
                } else {
                    this.selectFieldList.setSelectedField({ name: fieldValue });
                }
            }

        }.bind(this);

        this.overrideFieldTypes = function () {
            if (['DATE_TIME'].indexOf(field.type) !== -1) {
                field.type = 'TIME_MINUTES_SECONDS';
            }
        };

        this.getOperationPickList = function () {
            var fieldDomains = [];
            this.pickListOperator = new Monet.UI.Fields.PickList();
            this.pickListOperator.setId('panelbuilder_operators');
            this.pickListOperator.setMandatory(true);

            for (var i = 0, length = this.operators.length; i < length; i++) {
                var comp = this.operators[i];
                fieldDomains.push({ description: comp.label, value: comp.value });
            }
            this.pickListOperator.setFieldDomains(fieldDomains);
            this.pickListOperator.render();

            return this.pickListOperator.rootEl;

        };

        this.renderSingleField = function (field) {

            this.fieldRendered = new Monet.UI.Fields.Render(field, entity).render();
            this.rootEl.innerHTML = '';
            this.rootEl.appendChild(this.fieldRendered.render());

        }.bind(this);

        this.renderField = function () {
            var fragment = document.createDocumentFragment();
            var fieldContainer = document.createElement('div');
            fieldContainer.className = fieldContainerClass;

            this.selectFieldList.beforeCreateList = function () {
                const availableType = field.type === 'TIME_MINUTES_SECONDS' ? 'SECONDS' : field.type;

                this.reduceToFieldTypes([availableType]);
            };
            this.selectFieldList.render();

            this.overrideFieldTypes();
            var render = new Monet.UI.Fields.Render(field, entity);
            this.fieldRendered = render.render();
            fragment.appendChild(this.selectFieldList.elFieldList);
            fragment.appendChild(this.getOperationPickList());
            fieldContainer.appendChild(this.fieldRendered.rootEl);
            fragment.appendChild(fieldContainer);

            return fragment;
        };

    };

    return ComplexField;

}());